module.exports = __webpack_public_path__ + "static/media/skater.307b91b9.jpeg";